import { render } from "./Outdoor.vue?vue&type=template&id=0f8daf8d"
import script from "./Outdoor.vue?vue&type=script&lang=js"
export * from "./Outdoor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__